import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface CategoryTabsProps {
  activeSlug: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeSlug, onCategoryChange }: CategoryTabsProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900">
            影片分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onCategoryChange(cat.slug)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}